<template>
  <div class="mixing-update-wrap">
    <!-- title / 조색기 관리(팝업) 버튼 -->
    <div class="flex-box flex-between">
      <h3 class="c-title-level3">MY 조색기 업데이트</h3>
      <button
        type="button"
        class="c-util-button type-line-black"
        @click="popupCmd('updatePopup')"
      >
        <span>조색기 관리</span>
      </button>
    </div>
    <!-- title / 조색기 관리(팝업) 버튼 -->

    <!-- 설정한 MY 조색기 리스트 -->
    <div class="c-mixing-card-area">
      <div
        class="c-mising-card"
        v-for="(item, idx) in data.list.myList"
        :key="idx"
      >
        <strong class="title"
          >{{ item.prdctSeNm }}-{{ item.cmmPntSeNm }}</strong
        >
        <button
          type="button"
          class="c-util-button type-line-black type-small"
          @click="popupCmd('detailPopup', item)"
        >
          <span> 상세내용 </span>
        </button>
        <span class="date"
          >{{
            item.infoUpDt != null
              ? "업데이트일: "
              : item.infoDt != null
                ? "등록 취소일: "
                : "미등록"
          }}
          <span class="system">{{
            item.infoUpDt != null
              ? item.infoUpDt
              : item.infoDt != null
                ? item.infoDt
                : null
          }}</span>
        </span>
        <div class="c-btn-area type-full">
          <button
            type="button"
            class="c-util-button type-primary"
            @click="btnCmd(item)"
          >
            <span>
              업데이트 다운로드<i
                class="c-icon icon-download-white-small size-small"
              ></i>
            </span>
          </button>
        </div>
      </div>
    </div>
    <!-- 설정한 MY 조색기 리스트 -->

    <!-- 간이 업데이트 -->
    <div class="simple-update-wrap">
      <h3 class="c-title-level3">간이 업데이트</h3>
      <!-- D: PC 전용 -->
      <div class="scroll-x only-pc">
        <div class="scroll-x-inner">
          <div class="c-table" style="width: 1102px">
            <table>
              <caption>
                조색 배합 문의 내역 - 제목, 일반/팬톤, 수성/유성, 등록일,
                다운로드 정보 제공 테이블
              </caption>
              <colgroup>
                <col />
                <col style="width: 140px" />
                <col style="width: 140px" />
                <col style="width: 140px" />
                <col style="width: 100px" />
              </colgroup>
              <thead>
                <tr>
                  <th class="ac" scope="row">제목</th>
                  <th class="ac" scope="row">일반/팬톤</th>
                  <th class="ac" scope="row">수성/유성</th>
                  <th class="ac" scope="row">등록일</th>
                  <th class="ac" scope="row">다운로드</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in data.list.updateList" :key="idx">
                  <td>
                    <a
                      href="javascript:void(0);"
                      class="hover-underline"
                      @click="popupCmd('detailPopup', item)"
                      v-html="sanitizeHTML(item.updtTitleNm)"
                    ></a>
                  </td>
                  <td class="ac">{{ item.prdctSeNm }}</td>
                  <td class="ac">{{ item.cmmPntSeNm }}</td>
                  <td class="ac">{{ item.fileRegDt || item.regDt }}</td>
                  <td class="ac">
                    <div>
                      <button type="button" @click="btnCmd(item)">
                        <i class="c-icon icon-download"></i>
                        <span class="sr-only">다운로드</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- // D: PC 전용 -->
      <!-- D: MO 전용 -->
      <div class="mo-mixing-update-list only-mo">
        <ul>
          <li
            class="item"
            v-for="(item, idx) in data.list.updateList"
            :key="idx"
          >
            <button
              type="button"
              class="btn"
              @click="popupCmd('detailPopup', item)"
            >
              <span
                v-if="item.cmmPntSeCd == 'WATER'"
                class="c-flag type-mising type-red"
              >
                <b>{{ item.prdctSeNm }}-{{ item.cmmPntSeNm }}</b>
              </span>
              <span
                v-if="item.cmmPntSeCd == 'OIL'"
                class="c-flag type-mising type-yellow"
              >
                <b>{{ item.prdctSeNm }}-{{ item.cmmPntSeNm }}</b>
              </span>
              <span
                v-if="item.cmmPntSeCd == 'COMPLEX'"
                class="c-flag type-mising type-purple"
              >
                <b>{{ item.prdctSeNm }}-{{ item.cmmPntSeNm }}</b>
              </span>
              <p class="text" v-html="item.updtTitleNm"></p>
              <span class="date"
                >등록일:
                <span class="system">{{ item.fileRegDt || item.regDt }}</span>
              </span>
            </button>
            <button type="button" class="btn-download" @click="btnCmd(item)">
              <i class="c-icon icon-download"></i>
              <span class="sr-only">다운로드</span>
            </button>
          </li>
        </ul>
      </div>
      <!-- // D: MO 전용 -->
    </div>

    <!-- D : pageing area -->
    <Pagination
      ref="paginationEl"
      v-if="!data.page.list || data.page.list.length > 0"
      :total-pages="data.page.totalPage"
      :per-page="data.page.limit"
      :show-select="true"
      @page-change="handlePageChange"
      @items-per-page-change="handleItemsPerPageChange"
    />
    <!-- // D : pageing area -->
  </div>

  <!-- D: POPUP - Wrap밖으로 호출 필요 -->
  <UpdateDetailDescPop
    v-if="data.popup.updateDetail"
    :data="data.detail.info"
    @close="closePop('updateDetail')"
  />
  <ColorCombinMngPop
    v-if="data.popup.colorCombin"
    :data="data.update.info"
    :my="data.update.my"
    @close="searchCmd('myList', { popFlag: false })"
  />
</template>

<script setup name="updateSearchList">
import { onMounted, reactive, inject, ref } from "vue";

import Pagination from "@/components/paintpro/base/pagination.vue";
import UpdateDetailDescPop from "@/components/paintpro/colorCombin/updateDetailDescPop.vue";
import ColorCombinMngPop from "@/components/paintpro/colorCombin/colorCombinMngPop.vue";

import { api } from "@/plugins/api";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

const url = inject("url_prefix");
const paginationEl = ref(null);

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  popup: {
    updateDetail: false,
    colorCombin: false,
  },
  // MY 조색기 업데이트 > 상세내용
  detail: {
    info: {},
  },
  // 조색기 관리 팝업
  update: {
    info: [],
    my: [],
  },
  list: {
    myList: [],
    updateList: [],
  },
  page: {
    page: 0, // 현재 페이지
    limit: 20, // 목록 조회 행수
    totalCount: 0,
    totalPage: 0,
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

// /*********************
//  * 페이지 초기함
//  *********************/
async function pageInit() {
  searchCmd("myList");
  searchCmd("updateList");
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", parms = {}) {
  // MY 조색기 업데이트
  if (cmd === "myList") {
    const res = await api.post(`${url}/colorCombin/selectMyUpdateList`, {
      agencySn: null,
    });

    // 초기 조색기 리스트트
    const initRes = await api.post(`${url}/colorCombin/selectInitList`, {
      agencySn: null,
    });

    if (res.data != null && res.data.length > 0) {
      let filList = res.data.filter(function (item) {
        return item.useYn == "Y";
      });

      // MY조색기 등록/미등록 여부에 따른 리스트 처리
      if (filList.length > 0) {
        data.list.myList = filList;
      } else {
        // 등록 취소한 조색기에 대한 정보 표기
        for (let i in res.data) {
          for (let j in initRes.data) {
            if (res.data[i].prdctSeCd == initRes.data[j].prdctSeCd) {
              if (res.data[i].cmmPntSeCd == initRes.data[j].cmmPntSeCd) {
                initRes.data[j].mdfcnDt = res.data[i].mdfcnDt;
              }
            }
          }
        }

        data.list.myList = initRes.data;
      }
      data.update.my = res.data;
      data.update.info = initRes.data;
    } else {
      data.list.myList = initRes.data;
      data.update.info = initRes.data;
    }

    if (parms.popFlag != null) {
      data.popup.colorCombin = parms.popFlag;
    }
  }

  // 간이 업데이트
  else if (cmd === "updateList") {
    const res = await api.post(`${url}/colorCombin/selectUpdateList`, {
      page: parms["page"] || 1,
      limit: parms["limit"] || data.page.limit,
    });
    if (parms["page"] == null || parms["page"] == 1) {
      paginationEl.value?.setCurrentPage(1);
    }

    data.list.updateList = res.data.list;

    data.page.page = parms["page"] || 1;
    data.page.totalCount = res.data.totalCount;
    data.page.totalPage = data.page.totalCount
      ? Math.ceil(data.page.totalCount / data.page.limit)
      : 0;
  }
}

/**********************
 * 팝업 모음
 *********************/
async function popupCmd(cmd = "", params = {}) {
  // 상세내용
  if (cmd === "detailPopup") {
    data.detail.info = params;
    data.popup.updateDetail = !data.popup.updateDetail;
  }
  // 조색기 관리 팝업
  else if (cmd === "updatePopup") {
    data.popup.colorCombin = !data.popup.colorCombin;
  } // 조색기 관리 팝업 닫기
  else if (cmd === "closeUpdateDetail") {
    data.popup.colorCombin = params.popFlag;
  }
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(params = {}) {
  cmApi.fileDownload(params);
}

/**********************
 * 페이징 모음
 *********************/
function handlePageChange(page) {
  searchCmd("search", { page: page });
}
function handleItemsPerPageChange(perPage) {
  data.page.limit = perPage;
  searchCmd("search", {});
}

/**********************
 * 팝업 기능
 *********************/
async function closePop(cmd = "") {
  if (cmd === "updateDetail") {
    data.popup.updateDetail = false;
  }
}

// script 태그와 이벤트 핸들러 제거
function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}

// // 아코디언 열린 위치로 스크롤 이동
// const goToSelectedPost = () => {
//   const id = route.params.id || "";
//   if (id) {
//     const idEl = document.getElementById(`ID${id}`);
//     let positionTop = idEl?.getBoundingClientRect().top || 0;
//     if (positionTop > 100) {
//       positionTop -= 95;
//     }
//     window.scroll({ top: positionTop });
//   }
// };
</script>

<style scoped></style>
